import React from "react";
import { StickyHeader, Footer } from "./components/landing-new";
import {
  HeroSection,
  WhyAndWho,
  AdditionalBenefits,
  LeaderShowcase,
  Exclusivity,
  TheJourney,
  CallToReflection,
  LeaderFAQ,
} from "./components/leader-programme";

const LeaderProgramme = () => {
  return (
    <div className="tw-min-h-screen tw-bg-white">
      <StickyHeader withoutCta />
      <HeroSection />
      <WhyAndWho />
      <AdditionalBenefits />
      <LeaderShowcase />
      <TheJourney />
      <CallToReflection />
      <LeaderFAQ />
    </div>
  );
};

export default LeaderProgramme;
